export { default as DevelopmentBNumber } from './page'


// WEBPACK FOOTER //
// ./src/pages/developmentBNumber/index.js